import React, { useCallback, useEffect } from "react";
import { useSetReviewSelectionMutation } from "../../api/api";
import { useToast } from "../../@/components/ui/use-toast";
interface ReviewSelectionSaveProps {
  productRatingIds: number[];
  vendorId: number;
  productId: number;
  onSaveSuccess: () => void;
}

const ReviewSelectionSave: React.FC<ReviewSelectionSaveProps> = ({
  productRatingIds,
  vendorId,
  productId,
  onSaveSuccess,
}) => {
  const [setReviewSelection, { isLoading }] = useSetReviewSelectionMutation();
  const { toast } = useToast();

  const fetchData = useCallback(async () => {
    try {
      const response = await setReviewSelection({
        setReviewSelectionRequestDto: {
          productRatingIds: productRatingIds,
          vendorId: vendorId,
          productId: productId,
        },
      });
      if (response.data?.message && response.data.message.includes("success")) {
        toast({
          title: "Review selection saved",
          description: "Review selection updated successfully",
        });
        onSaveSuccess();
      } else {
        toast({
          title: "Review selection failed",
          description: "Review selection failed to Saved",
        });
      }
    } catch (error) {
      console.error("Error saving review selection:", error);
      toast({
        title: "Error",
        description: "Failed to save review selection",
        variant: "destructive",
      });
    }
  }, [
    setReviewSelection,
    productRatingIds,
    vendorId,
    productId,
    onSaveSuccess,
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="fixed inset-0 bg-black/30 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg text-center">
        {isLoading ? (
          <div className="flex flex-col items-center gap-2">
            <div className="w-6 h-6 border-2 border-customGreenColor border-t-transparent rounded-full animate-spin" />
            <p>Saving review selections...</p>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ReviewSelectionSave;
